import { createContext, useContext } from 'react';

export const DealIdContext = createContext();
DealIdContext.displayName = 'DealIdContext';

export function useDealId() {
  return useContext(DealIdContext);
}
